module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_6005.7dd9ddd6.png";